<template>
	<div class="animated fadeIn">
		<b-tabs v-model="activeTab">
			<b-tab title="Предстоящие">
				<event-list
					:startAt="startAt"
				/>
			</b-tab>
			<b-tab title="Прошедшие"></b-tab>
		</b-tabs>
	</div>
</template>
<script>
import moment from 'moment'
import EventList from '@/components/event/event-list'
export default {
	components: {
		'event-list': EventList
	},
	data () {
		return {
			activeTab: 0,
			tabs: {
				0: '',
				1: 'past'
			},
			startAt: moment().format('Y-MM-DD')
		}
	},
	watch: {
		activeTab: function (value) {
			let path = '/events'
			path = this.tabs[value] === '' ? path + '' : path + '/' + this.tabs[value]
			this.$router.push({path: path})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/event/indexTabs/index.vue